<ng-container *ngIf="job.state !== DistributionJobState.SENT">

    <div class="row no-gutters">

        <div class="col-xs-12 col-sm-6">
            <div class="row no-gutters">
                <div class="col-10">
                    <mat-form-field class="full-width"
                                    *ngIf="claimsNetRecipientOptions">
                        <mat-label>{{ job.trans.recipient | translate }}</mat-label>
                        <mat-select id="{{idPrefix}}{{job.trans.recipient}}"
                                    [formControl]="selectedRecipientOptions"
                                    (ngModelChange)="updateRecipientOptions()"
                                    [disabled]="disabled"
                                    [required]="isCaseDistributionJob">
                            <mat-option *ngFor="let recipient of claimsNetRecipientOptions.items; let idx = index"
                                        id="{{idPrefix}}{{job.trans.recipient}}.item_{{idx}}"
                                        [value]="recipient">
                                {{ recipient.actionListDisplayName }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="selectedRecipientOptions.invalid">{{ 'common.label.required' | translate | titlecase }}</mat-error>
                    </mat-form-field>
                </div>

                <div class="col-2"></div>
            </div>
        </div>

        <div class="col-xs-12 col-sm-6">
            <div class="row no-gutters">
                <div class="col-sm-10">
                    <dr-checkbox *ngIf="selectedRecipientOptions"
                                 [boolValue]="selectedRecipientOptions.value && selectedRecipientOptions.value.remove_images"
                                 [label]="job.trans.print_remove_pictures | translate"
                                 [idPrefix]="idPrefix"
                                 [idSuffix]="job.trans.print_remove_pictures"
                                 [disabled]="true">
                    </dr-checkbox>
                </div>

                <div class="col-2"></div>
            </div>
        </div>

    </div>

</ng-container>

<ng-container *ngIf="job.state === DistributionJobState.SENT">
    <div class="p-4">

        <div class="row">
            <div class="col-sm-4 col-lg-2">
                <strong>{{ job.trans.recipient | translate}}: </strong>
            </div>
            <div class="col-sm-8 col-lg-10">
                <span>{{ job.recipient_name }}</span>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-4 col-lg-2">
                <strong>{{ job.trans.print_remove_pictures | translate}}: </strong>
            </div>
            <div class="col-sm-8 col-lg-10">
                <span>{{ (job.print_remove_pictures ? 'common.btn.yes' : 'common.btn.no') | translate }}</span>
            </div>
        </div>

    </div>
</ng-container>
